document.addEventListener("DOMContentLoaded", function () {
  const box = document.querySelector('.timer__box');
  if (!box) return;


  function getTimeZoneOffsetForUTC(utcDate, timeZone) {
    const dtf = new Intl.DateTimeFormat('en-GB', {
      timeZone,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    });
    const parts = dtf.formatToParts(utcDate).reduce((acc, p) => { acc[p.type] = p.value; return acc; }, {});
    const asUTC = Date.UTC(+parts.year, (+parts.month) - 1, +parts.day, +parts.hour, +parts.minute, +parts.second);
    return asUTC - utcDate.getTime(); 
  }

  function zonedEndToUTC(endStr, timeZone) {
    const m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?$/.exec((endStr || "").trim());
    if (!m) return null;
    const [_, y, mo, d, h, mi, s] = m;
    const pretendUTC = Date.UTC(+y, +mo - 1, +d, +h, +mi, +(s || 0));
    const offsetMs = getTimeZoneOffsetForUTC(new Date(pretendUTC), timeZone);
    return pretendUTC - offsetMs;
  }

  function pad2(n) { return String(n).padStart(2, '0'); }

  function render(totalSec) {
    const elDays    = document.getElementById("timer-days");
    const elHours   = document.getElementById("timer-hours");
    const elMinutes = document.getElementById("timer-minutes");
    const elSeconds = document.getElementById("timer-seconds");
    const labelDays = document.getElementById("timer-days-label");

    const d = Math.max(0, Math.floor(totalSec / 86400));
    const h = Math.max(0, Math.floor((totalSec % 86400) / 3600));
    const m = Math.max(0, Math.floor((totalSec % 3600) / 60));
    const s = Math.max(0, Math.floor(totalSec % 60));

    if (elDays)    elDays.textContent    = pad2(d);
    if (elHours)   elHours.textContent   = pad2(h);
    if (elMinutes) elMinutes.textContent = pad2(m);
    if (elSeconds) elSeconds.textContent = pad2(s);

    if (labelDays) {
      const daySing = labelDays.dataset.singular || 'Tag';
      const dayPlur = labelDays.dataset.plural   || 'Tage';
      labelDays.textContent = (d === 1) ? daySing : dayPlur;
    }
  }


  const endStr        = box.getAttribute('data-end') || '';
  const tz            = (box.getAttribute('data-timezone') || 'Europe/Berlin').trim();
  const hideWhenEnded = (box.getAttribute('data-hide-when-ended') || 'true') === 'true';

  const endUTC = zonedEndToUTC(endStr, tz);
  if (!endUTC) {
    box.style.display = 'none';
    return;
  }

  function tick() {
    const nowUTC = Date.now();
    const diffMs = endUTC - nowUTC;

    if (diffMs <= 0) {
      render(0);
      if (hideWhenEnded) box.style.display = 'none';
      clearInterval(interval);
      return;
    }

    render(Math.floor(diffMs / 1000));
  }

  tick();
  const interval = setInterval(tick, 1000);
});